module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"referring_domains":"Referring Domains"},"fr":{"referring_domains":"Domaines référents"},"de":{"referring_domains":"Verweisende Domains"}}')
  delete Component.options._Ctor
}
